import React, { useRef, forwardRef, MutableRefObject } from 'react';
import styled, { css } from 'styled-components';
import {
  useLayoutMode,
  TLayoutMode,
} from '@hox/frontend-utils/hooks/useLayoutMode';

export interface ICardStyledProps {
  layoutMode: TLayoutMode;
}

const CardStyled = styled.div`
  position: relative;
  display: block;
  box-sizing: border-box;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.05);
  padding: 2rem;

  ${({ layoutMode }: ICardStyledProps) =>
    layoutMode !== 'small' &&
    css`
      padding: 3rem;
    `}

  border-radius: 0.5rem;
  background-color: ${({ theme }) => theme.palette.background.card};
  color: ${({ theme }) => theme.palette.foreground.primary};
  text-decoration: none;
`;

export const Card = forwardRef<
  HTMLDivElement,
  IExtendedHTMLProps<HTMLDivElement, {}>
>((props, forwardedRef) => {
  const ref = useRef(null);
  const whichRef = (forwardedRef || ref) as MutableRefObject<HTMLDivElement>;
  const layoutMode = useLayoutMode(whichRef);
  return <CardStyled {...props} ref={whichRef} layoutMode={layoutMode} />;
});

// eslint doesn't do forwardRef's types properly
Card.displayName = 'Card';
